export default __webpack_public_path__ + "static/media/Dewey-Panic-Grass_L2.dc7ec897.png";